import { ReactNode, RefObject, useState } from "react";

import { isEllipsisActive } from "utils/browser";

import styles from "./styles.module.css";
import Tooltip from "../Tooltip";
import { TooltipProps, TooltipReferenceProps } from "../Tooltip/types";

type TextEllipsisProps = {
  tooltipPlacement?: TooltipProps["placement"];
  tooltipWidthMode?: TooltipProps["widthMode"];
  tooltipMode?: TooltipProps["mode"];
  children: (props: TooltipReferenceProps, isActive: boolean) => ReactNode;
  tooltip: ReactNode;
  delay?: number;
  mode?: "single" | "line-clamp";
  forceTooltipActive?: boolean;
  tooltipOffset?: number;
};

const TextEllipsis = (props: TextEllipsisProps) => {
  const {
    children,
    tooltip,
    delay,
    tooltipPlacement,
    tooltipWidthMode,
    tooltipMode,
    mode = "single",
    tooltipOffset,
    forceTooltipActive,
  } = props;

  const [isTooltipActive, setTooltipActive] = useState(false);

  const initializeEllipsis = (innerRef: RefObject<HTMLElement | null>) => {
    if (innerRef.current) {
      setTooltipActive(isEllipsisActive(innerRef.current, mode === "line-clamp"));
    }
  };

  return (
    <Tooltip
      active={isTooltipActive || forceTooltipActive}
      widthMode={tooltipWidthMode}
      placement={tooltipPlacement}
      mode={tooltipMode}
      onChildrenChangedCallback={initializeEllipsis}
      delay={delay}
      triggerClassName={styles.textEllipsis}
      on={(props) => children(props, isTooltipActive)}
      offset={tooltipOffset}
    >
      {tooltip}
    </Tooltip>
  );
};

TextEllipsis.displayName = "DS.TextEllipsis";

export default TextEllipsis;
